<div class="main">
    <div class="center-screen has-text-centered">
    <app-loginform RedirectUrl=""></app-loginform>
    </div>
</div>